import { ActionDescriptor } from '../common/commonTypes';
import AddAttributeForm from './AddAttributeForm';

const addAttribute: ActionDescriptor = {
	FormComponent: AddAttributeForm,
	actionTitle: 'Add',
};

export default addAttribute;
